import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Nav from './nav';
import Header from './header';
import Guest from './guest';
import Banner from './banner';
import FootIntro from './footIntro';
import CopyRight from './copyRight';
import BannerSwiper from './bannerSwiper';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    dataFilter = (data, title) => {
        let filterData = [];

        if (data && data.length > 0) {
            data.forEach(item => {
                if (
                    item.display &&
                    item.title === title &&
                    item.data &&
                    item.data.articleList &&
                    item.data.articleList.length > 0
                ) {
                    filterData = item.data.articleList;

                    filterData = filterData.map(item => {
                        const base62Id =
                            (item.commentUrl && item.commentUrl.replace('ucms_', '')) ||
                            (item.url && item.url.split('/').pop()) ||
                            '';

                        return {
                            ...item,
                            type: item.type === 'short' ? 'article' : item.type,
                            base62Id,
                            newStyle: 'titleimg',
                            // url: `https://ishare.ifeng.com/c/s/${base62Id}`,
                        };
                    });
                }
            });
        }

        return filterData;
    };

    transformJSX(html) {
        return { __html: html };
    }

    render() {
        const {
            content: { modules, base62Id, bottomCooper, bottomCopyright, nav },
        } = this.props;

        const bannerData = this.dataFilter(modules, '首屏');
        const guestData = this.dataFilter(modules, '首屏');

        const cooper = decodeURIComponent(bottomCooper);

        return (
            <>
                {nav && <Header content={nav} />}
                {<BannerSwiper />}
                <Nav content={bannerData} base62Id={base62Id} />
                {bannerData.length > 0 && <Banner content={bannerData} />}
                {guestData.length > 0 && <Guest content={guestData} />}
                <div style={{ backgroundColor: '#fff' }}>
                    <img
                        src="//x0.ifengimg.com/ucms/2021_14/0BEC02B8E92EC07B699F45D7B8AC8174029727D6_size49_w1000_h180.jpg"
                        alt=""
                        style={{ margin: '0 auto', display: 'block' }}
                    />
                </div>
                <div style={{ backgroundColor: '#fff' }}>
                    <FootIntro />
                </div>
                <div
                    dangerouslySetInnerHTML={this.transformJSX(cooper)}
                    style={{ marginTop: '35px', backgroundColor: '#fff', borderTop: '1px solid #e6e6e6' }}
                />
                {bottomCopyright && <CopyRight content={bottomCopyright} />}
            </>
        );
    }
}

export default errorBoundary(Layout);
